<t4-header icon="glyphicon-stats"></t4-header>

<t4-container title="{{ 'T4.ContextTree' | translate : 'Context Tree' }}">
  <div class="content" [@formState]="subForms.loading" style="margin-top: calc((100% - 160px) / 2); margin-left: calc((100% - 100px)/2); height: 100px;">
    <mat-spinner mode="indeterminate" style="top"></mat-spinner>
  </div>
  <div>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <div class="contextRow" style="background-image: url({{node.imageurl}})"></div>
        <span style="cursor:pointer" (click)="contextDialog(node)"><b>{{node.name}}</b></span> <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>library_add</mat-icon></button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="createNewGroup(node)">Create group</button>
          <button mat-menu-item>Rename</button>
          <button mat-menu-item (click)="uploadLogo(node)">Upload logo</button>
          <button mat-menu-item (click)="uploadPin(node)">Upload Pin</button>
          <button mat-menu-item disabled>Disable</button>
        </mat-menu>
      </mat-tree-node>
    </mat-tree>
  </div>
